import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/estate", label: "The Estate", testid: "nav-link-estate" },
  { to: "/weddings", label: "Weddings", testid: "nav-link-weddings" },
  { to: "/retreats", label: "Retreats", testid: "nav-link-retreats" },
  { to: "/gallery", label: "Gallery", testid: "nav-link-gallery" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "bg-[#1E1610]/90 backdrop-blur-md shadow-lg shadow-black/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-16">
        <Link to="/" data-testid="nav-logo" aria-label="Plas Llechylched home">
          <Logo light />
        </Link>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-[#C89D56] ${
                  isActive ? "text-[#C89D56]" : "text-[#F4F1EA]/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/enquire"
            data-testid="nav-enquire-button"
            className="rounded-full bg-[#B85D43] px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-[#F4F1EA] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#C89D56] hover:text-[#1E1610]"
          >
            Enquire
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="text-[#F4F1EA] lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="border-t border-[#F4F1EA]/10 bg-[#1E1610]/95 px-4 pb-6 pt-2 backdrop-blur-md lg:hidden" aria-label="Mobile">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `block py-3 font-serif text-2xl ${isActive ? "text-[#C89D56]" : "text-[#F4F1EA]/85"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/enquire"
            data-testid="nav-enquire-button-mobile"
            className="mt-3 inline-block rounded-full bg-[#B85D43] px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-[#F4F1EA]"
          >
            Enquire
          </Link>
        </nav>
      )}
    </header>
  );
}
